import { UIState, UIAction, UIActionType, HIGHLIGHT_DURATION_MS } from './types'

export const initialUIState: UIState = {
  highlightedRows: new Map(),
  selectedOfficial: null,
  isOfficialModalOpen: false,
  isAddPlayerSheetOpen: false,
}

export const uiReducer = (state: UIState, action: UIAction): UIState => {
  switch (action.type) {
    case UIActionType.ADD_HIGHLIGHTED_ROW: {
      const newHighlighted = new Map(state.highlightedRows)
      newHighlighted.set(action.payload.id, {
        type: action.payload.highlightType,
        addedAt: action.payload.addedAt,
      })
      return { ...state, highlightedRows: newHighlighted }
    }

    case UIActionType.CLEAR_EXPIRED_HIGHLIGHTS: {
      const now = action.payload
      let hasExpired = false
      state.highlightedRows.forEach((entry) => {
        if (now - entry.addedAt >= HIGHLIGHT_DURATION_MS) {
          hasExpired = true
        }
      })
      if (!hasExpired) {
        return state
      }
      const newHighlighted = new Map(state.highlightedRows)
      newHighlighted.forEach((entry, id) => {
        if (now - entry.addedAt >= HIGHLIGHT_DURATION_MS) {
          newHighlighted.delete(id)
        }
      })
      return { ...state, highlightedRows: newHighlighted }
    }

    case UIActionType.SET_SELECTED_OFFICIAL:
      return { ...state, selectedOfficial: action.payload }

    case UIActionType.SET_OFFICIAL_MODAL_OPEN:
      return { ...state, isOfficialModalOpen: action.payload }

    case UIActionType.SET_ADD_PLAYER_SHEET_OPEN:
      return { ...state, isAddPlayerSheetOpen: action.payload }

    default:
      return state
  }
}
